import { useAtom } from '@reatom/npm-react'
import BigNumber from 'bignumber.js'
import { AnimatePresence } from 'motion/react'
import { useState } from 'react'

import { useTranslation } from '@root/shared/localization'
import { ChargeExactIcon } from '@root/shared/ui-kit'

import { QuickSellModal } from './quick-sell-modal'
import { SellButton } from './sell-button'

import type {
  AggregatedPositionModel,
  WalletPositionModel,
} from '@root/entities/position'
import type { ClassNameProps } from '@root/shared/react'

type SellPositionButtonProps = {
  position: AggregatedPositionModel | WalletPositionModel | undefined
} & ClassNameProps

export const SellPositionButton: React.FC<SellPositionButtonProps> = ({
  className,
  position,
}) => {
  const { t } = useTranslation()
  const [positionToSell, setPositionToSell] = useState<
    AggregatedPositionModel | WalletPositionModel | undefined
  >(undefined)

  const handleClick = () => {
    setPositionToSell(position)
  }

  const [positionSizeCurrency] = useAtom((ctx) => {
    if (!position) {
      return BigNumber(0)
    }
    return ctx.spy(position.remainingSizeCurrency)
  })

  const emptyPosition = positionSizeCurrency.isZero()

  return (
    <>
      <SellButton
        disabled={emptyPosition}
        className={className}
        onClick={handleClick}
      >
        <ChargeExactIcon width={8} />
        {t('trading.sell')}
      </SellButton>
      <AnimatePresence>
        {positionToSell ? (
          <QuickSellModal
            onOpenChange={(open) => {
              if (!open) {
                setPositionToSell(undefined)
              }
            }}
            position={positionToSell}
            open
          />
        ) : undefined}
      </AnimatePresence>
    </>
  )
}
